<template>
  <section>
    <h2>應用庫</h2>
    <b-button
      variant="outline-secondary"
      class="mb-3"
      :disabled="isLoadingApplications || isDeletingApplication"
      @click="loadApplications"
    >
      <b-icon icon="arrow-clockwise" aria-hidden="true" />
      更新應用列表
    </b-button>
    <b-alert :show="Boolean(applicationsError)" variant="danger">
      {{ applicationsError }}
    </b-alert>
    <b-alert :show="Boolean(applicationDeleteError)" variant="danger">
      {{ applicationDeleteError }}
    </b-alert>
    <p v-if="isLoadingApplications">讀取應用庫中…</p>
    <b-table
      :items="applications"
      :fields="fields"
      responsive
      show-empty
      empty-text="目前沒有應用紀錄"
      :busy="isLoadingApplications"
    >
      <template #cell(actions)="data">
        <b-button
          variant="outline-secondary"
          title="查看判斷標準"
          aria-label="查看判斷標準"
          @click="showApplication(data.item)"
        >
          <b-icon icon="eye" aria-hidden="true" />
        </b-button>
        <b-button
          variant="outline-danger"
          class="ml-2"
          :disabled="isLoadingApplications || isDeletingApplication"
          title="刪除應用"
          aria-label="刪除應用"
          @click="deleteApplication(data.item)"
        >
          <b-icon icon="trash" aria-hidden="true" />
        </b-button>
      </template>
    </b-table>

    <b-modal ref="applicationModal" title="判斷標準" ok-only ok-title="關閉">
      <template v-if="selectedApplication">
        <p>{{ selectedApplication.name }}</p>
        <b-form-textarea
          :value="selectedApplication.content.prompt"
          readonly
          rows="8"
          aria-label="判斷標準全文"
        />
      </template>
    </b-modal>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "QAApplications",

  data() {
    return {
      applications: [],
      isLoadingApplications: false,
      isDeletingApplication: false,
      applicationDeleteError: "",
      applicationsError: "",
      fields: [
        { key: "name", label: "名稱" },
        { key: "criterionName", label: "準則庫" },
        { key: "statsSummary", label: "統計摘要" },
        { key: "actions", label: "操作" },
      ],
      selectedApplication: null,
    };
  },
  methods: {
    async loadApplications() {
      if (this.isLoadingApplications) return;
      this.isLoadingApplications = true;
      this.applicationsError = "";

      try {
        const base = process.env.VUE_APP_API_BASE;
        if (!base) throw new Error("尚未設定 API 網址");
        const response = await axios.get(
          `${base.replace(/\/+$/, "")}/api/qa/applications`,
        );

        this.applications = response.data.map((entry) => {
          const stats = entry.content.stats;
          const value = (number) =>
            Number.isFinite(number) ? number.toFixed(3) : "無資料";
          const method = stats?.method === "kappa" ? "Kappa" : "Pearson r";
          return {
            ...entry,
            statsSummary: stats
              ? `${method}：最低 ${value(stats.min)}，平均 ${value(stats.mean)}`
              : "無統計摘要",
          };
        });
        this.selectedApplication = null;
        this.$refs.applicationModal.hide();
      } catch (error) {
        this.applicationsError =
          error.response?.data?.message || error.message || "讀取應用庫失敗";
      } finally {
        this.isLoadingApplications = false;
      }
    },
    async deleteApplication(application) {
      if (this.isLoadingApplications || this.isDeletingApplication) return;
      this.isDeletingApplication = true;
      this.applicationDeleteError = "";

      try {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          `確定刪除「${application.name}」（ID：${application.id}）？`,
          {
            title: "刪除應用",
            okTitle: "刪除",
            cancelTitle: "取消",
            okVariant: "danger",
          },
        );
        if (!confirmed) return;

        const base = process.env.VUE_APP_API_BASE;
        if (!base) throw new Error("尚未設定 API 網址");
        await axios.delete(`${base.replace(/\/+$/, "")}/api/qa/applications`, {
          params: { id: application.id },
        });

        this.selectedApplication = null;
        this.$refs.applicationModal.hide();
        await this.loadApplications();
      } catch (error) {
        this.applicationDeleteError =
          error.response?.data?.message || error.message || "刪除應用失敗";
      } finally {
        this.isDeletingApplication = false;
      }
    },
    showApplication(application) {
      this.selectedApplication = application;
      this.$refs.applicationModal.show();
    },
  },
  mounted() {
    this.loadApplications();
  },
};
</script>
